// Textos de las pestañas de la ficha de usuario del backoffice (user-detail-tabs). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    USER_DETAIL_TABS: {
      ROUTES: {
        VIEW_FRAUD_TAB: 'Amb senyals de frau',
        SIGNAL_TRIPS_NONE_SENTENCE: 'Cap viatge amb senyals.',
        DECISION_IN_FRAUD: 'La decisió es pren a Frau.',
        SHOWING: 'Mostrant {{count}} de {{total}} viatges',
        SHOWING_FRAUD: 'Mostrant {{count}} de {{total}} viatges amb senyals (els més sospitosos)',
        TITLE: 'Viatges',
        SUBTITLE:
          "Trajectes de l'usuari com a conductor o passatger. Fes clic en un per veure qui anava al cotxe; amb la fletxa › obres el viatge.",
        RELOAD: 'Recarrega',
        SEARCH_PLACEHOLDER: 'Cerca per rutina…',
        SEARCH_ARIA: 'Cerca per rutina',
        ROLE_ARIA: 'Rol',
        ROLE_ALL: 'Rol: tots',
        ROLE_DRIVER: 'Conductor',
        ROLE_RIDER: 'Passatger',
        UNVERIFIED_IDENTITY: 'Sense identitat verificada',
        UNVERIFIED_IDENTITY_HINT: 'Va fer aquest viatge sense la identitat verificada',
        ALL: 'Tots',
        STATUS_ARIA: 'Estat del viatge',
        STATUS_ALL: 'Estat: tots',
        FOOTPRINT_ARIA: 'Petjada',
        FOOTPRINT_DEFAULT: 'Petjada: totes',
        FOOTPRINT_VERIFIED: 'Verificada',
        FOOTPRINT_REJECTED: 'Rebutjada',
        FOOTPRINT_PENDING: 'Pendent',
        FOOTPRINT_DECIDED: 'Verificada o rebutjada',
        FOOTPRINT_FACE_HOLD: 'Retinguda',
        FOOTPRINT_FACE_HOLD_HINT: 'Retinguda per la verificació facial fins al {{date}}. Fins aleshores no es verifica la petjada.',
        FOOTPRINT_FACE_HOLD_HINT_NO_DATE: "Retinguda per la verificació facial. La data d'alliberament es fixa en la primera passada de la verificació.",
        FOOTPRINT_APP_VERIFYING: "A l'app: «Verificando»",
        FOOTPRINT_VERIFYING_HINT: "Verificada, però el conductor encara no ha cobrat (pagament ajornat per retard de caixa o per verificació reforçada). Fins que cobri, l'app mostra «Verificando».",
        NO_FOOTPRINT: 'Sense petjada',
        FROM: 'Des de',
        TO: 'Fins a',
        CLEAR_FILTERS: 'Neteja els filtres',
        LOADING: 'Carregant viatges…',
        RETRY: 'Torna-ho a provar',
        EMPTY_FILTERED: 'Cap viatge coincideix amb els filtres.',
        EMPTY: 'Aquest usuari no té viatges.',
        TH_DATE: 'Data',
        TH_ROUTE: 'Trajecte',
        TH_ROLE: 'Rol',
        CAR_SHOW: 'Veure qui anava al cotxe',
        CAR_HIDE: 'Amagar el cotxe',
        CAR_LOADING: 'Carregant el cotxe…',
        CAR_ERROR: "No s'ha pogut carregar qui anava al cotxe.",
        CAR_PICKUP_ORDER: 'recollida núm. {{n}}',
        CAR_PEOPLE_ONE: '{{n}} persona',
        CAR_PEOPLE_MANY: '{{n}} persones',
        CAR_TITLE: 'Al cotxe',
        CAR_PAYS: 'Paga',
        CAR_EARNS: 'Cobra',
        CAR_THIS_USER: 'Aquest usuari',
        TH_ROUTINE: 'Rutina',
        TH_STATUS: 'Estat',
        TH_FOOTPRINT: 'Petjada',
        OPEN: 'Obre',
        VIEW_TRIP: 'Veure viatge',
        PAGE: 'Pàgina',
        OF: 'de',
        PREV_PAGE: 'Pàgina anterior',
        NEXT_PAGE: 'Pàgina següent',
        OPT_PENDING: 'Pendent',
        OPT_IN_PROGRESS: 'En curs',
        OPT_COMPLETED: 'Completada',
        OPT_CANCELLED: 'Cancel·lada',
        OPT_VERIFIED: 'Verificada',
        STATUS_PENDING: 'Pendent',
        STATUS_IN_PROGRESS: 'En curs',
        STATUS_COMPLETED: 'Completat',
        STATUS_CANCELLED: 'Cancel·lat',
        STATUS_VERIFIED: 'Verificat',
        STATUS_REJECTED: 'Rebutjat',
        STATUS_DELETED: 'Esborrat',
        STATUS_DELETED_F: 'Esborrada',
        SEATS_OCCUPANTS: '{{n}} ocupants',
        SEATS: '{{current}}/{{available}} places',
        ERROR_LOAD: "No s'ha pogut carregar el llistat de viatges de l'usuari.",
        PAGINATION: '{{from}}-{{to}} de {{total}}',
        FRAUD_TITLE: 'Frau:',
        SCORE: 'Score',
        SIGNAL_TRIPS_NONE: 'cap viatge amb senyals',
        SIGNAL_TRIPS_ONE: '{{n}} viatge amb senyals',
        SIGNAL_TRIPS_MANY: '{{n}} viatges amb senyals',
        MANAGE_FRAUD: 'Gestiona a Frau',
        VIEW_ARIA: 'Viatges a mostrar',
        VIEW_ALL: 'Tots els viatges',
        VIEW_FRAUD: 'Amb senyals de frau ({{n}})',
        TH_PASSENGERS: 'Passatgers',
        TH_SIGNALS: 'Senyals',
        TH_MONEY: 'Diners',
        TH_MODE: 'Modalitat',
        TH_FRAUD: 'Frau',
        DRIVER_COLON: 'Conductor:',
        NO_MATCH: 'Sense match',
        NO_PRICE: 'Sense preu',
        FREE_TRIP: 'Viatge gratuït',
        UNTIL: 'fins al {{date}}',
        SHOWING_MOST: 'Es mostren els {{shown}} més sospitosos de {{total}}.',
        LOW_SIGNALS: 'Senyals baixos',
        ERROR_FRAUD: "No s'ha pogut carregar la informació de frau.",
        COLLUSION_PAIRS_TITLE: 'Col·lusió per parella',
        COLLUSION_PAIRS_TEXT: "Amb qui no sembla una persona independent, segons l'equip de dades. Més alt = pitjor.",
        TH_PERSON: 'Persona',
        TH_COLLUSION: 'Col·lusió',
        TH_TRIPS_TOGETHER: 'Viatges junts',
        TH_LAST_VALUE: 'Últim valor',
        TH_HISTORY: 'Historial',
        HISTORY_SHOW: 'Historial ({{n}})',
        HISTORY_HIDE: 'Amagar historial',
        TRIPS_TOGETHER_N: '{{n}} viatges junts',
        PAYOUT_PAID: 'Pagat',
        PAYOUT_HELD: 'Retingut',
        PAYOUT_UNPAID: 'Sense cobrar',
        FRAUD_BLACKLIST: 'Llista negra',
        FRAUD_WHITELIST: 'Llista blanca',
        FRAUD_REINFORCED_NOCOST: 'Reforçada + sense cost 0',
        FRAUD_REINFORCED: 'Verificació reforçada',
        FRAUD_NOCOST: 'Sense cost 0',
        FRAUD_ALLOW: 'No frau',
        FRAUD_NONE: 'Sense decisió',
        SIG_GPS: 'GPS',
        SIG_COLLISION: "Col·lusió",
        SIG_COPRESENCE: 'Copresència',
        SIG_NETWORK: 'Xarxa/IP',
        SIG_TRANSPORT: 'Transport',
      },
      MOVEMENTS: {
        SHOWING: 'Mostrant <b>{{count}}</b> de <b>{{total}}</b> moviments',
        TITLE: 'Moviments de la cartera',
        SUBTITLE:
          "Els cobraments d'un mateix viatge s'agrupen en una fila; desplega-la per veure quant va pagar cada passatger.",
        RELOAD: 'Recarrega',
        NOT_GROUPED:
          "El backend d'aquest entorn encara no agrupa els cobraments per viatge: es mostren un a un.",
        LOADING: 'Carregant moviments…',
        RETRY: 'Torna-ho a provar',
        EMPTY: 'Aquest usuari no té moviments a la seva cartera.',
        EXPAND: 'Desplega',
        TH_DATE: 'Data',
        TH_TYPE: 'Tipus',
        TH_CONCEPT: 'Concepte',
        TH_AMOUNT: 'Import',
        TH_BALANCE: 'Saldo després del moviment',
        NO_NAME: 'Passatger sense nom',
        BALANCE: 'Saldo',
        PAGE: 'Pàgina',
        OF: 'de',
        PREV_PAGE: 'Pàgina anterior',
        NEXT_PAGE: 'Pàgina següent',
        PAGINATION: '{{from}}–{{to}} de {{total}}',
        ERROR_LOAD:
          "No s'han pogut carregar els moviments de la cartera de l'usuari.",
        TYPES: {
          withdrawal: 'Retirada',
          instant_withdrawal: 'Retirada instantània',
          instant_payout_fee: 'Comissió retirada instantània',
          instant_payout_refund: 'Devolució retirada instantània',
          income: 'Ingrés',
          waiis_commission: 'Comissió WAIIS',
          trip_income: 'Ingrés per trajecte',
          trip_payment: 'Pagament de trajecte',
          saas_commission: 'Comissió subscripció SaaS',
          manual_income: 'Ingrés manual',
          manual_withdrawal: 'Retirada manual',
          other: 'Altres',
        },
        CONCEPT: {
          TRIP_GROUPED_ONE: 'Viatge compartit · {{count}} passatger',
          TRIP_GROUPED_OTHER: 'Viatge compartit · {{count}} passatgers',
          withdrawal: 'Retirada #{{id}}',
          instant_withdrawal: 'Retirada instantània #{{id}}',
          instant_payout_fee: 'Comissió retirada instantània · transferència #{{id}}',
          instant_payout_refund: 'Devolució de retirada instantània',
          income: 'Ingrés #{{id}}',
          waiis_commission: 'Comissió WAIIS · transferència #{{id}}',
          trip_income: 'Ingrés per trajecte · transferència #{{id}}',
          saas_commission: 'Comissió subscripció SaaS · transferència #{{id}}',
          trip_payment: 'Pagament de trajecte',
          other: 'Un altre moviment',
        },
      },
      DEPOSIT: {
        SAVING: 'Desant…',
        ERROR_SAVE_TITLE: "No s'ha pogut desar el moviment",
        TITLE: 'Nou moviment a la cartera',
        SUBTITLE:
          "Ingressa o retira saldo manualment. L'usuari veurà el motiu als seus moviments.",
        KIND_ARIA: 'Tipus de moviment',
        KIND_DEPOSIT: 'Ingrés',
        KIND_DEPOSIT_HINT: "Afegeix saldo a l'usuari",
        KIND_WITHDRAW: 'Retirada',
        KIND_WITHDRAW_HINT: "Descompta saldo de l'usuari",
        AMOUNT: 'Import',
        REASON: 'Motiu',
        REASON_PLACEHOLDER: 'Explica per què es fa el moviment',
        REASON_1: 'Compensació per una incidència en un viatge',
        REASON_2: "Devolució d'un cobrament duplicat",
        REASON_3: 'Bonificació promocional',
        REASON_4: 'Correcció de saldo',
        PROCESSING: 'Processant…',
        ACTION_WITHDRAW: 'Retirar saldo',
        ACTION_DEPOSIT: 'Ingressar saldo',
        PREVIEW_ARIA: 'Previsualització del saldo',
        SUMMARY: 'Resum',
        CURRENT_BALANCE: 'Saldo actual',
        NOT_AVAILABLE: 'No disponible',
        BALANCE_AFTER: 'Saldo després del moviment',
        EXCEEDS: "La retirada supera el saldo de l'usuari.",
        LOGGED_WITHDRAW:
          'Queda registrat com a «Retirada manual» a la pestanya Moviments.',
        LOGGED_DEPOSIT:
          'Queda registrat com a «Ingrés manual» a la pestanya Moviments.',
        OK: 'OK',
        ERROR_TITLE: 'Error',
        SUCCESS_WITHDRAW_TITLE: 'Retirada realitzada',
        SUCCESS_DEPOSIT_TITLE: 'Ingrés realitzat',
        SUCCESS_WITHDRAW_TEXT:
          "L'import s'ha retirat correctament de la cartera de l'usuari.",
        SUCCESS_DEPOSIT_TEXT:
          "L'import s'ha afegit correctament a la cartera de l'usuari.",
        ERROR_MOVEMENT:
          "No s'ha pogut fer el moviment a la cartera de l'usuari.",
        ERR_REQUIRED: 'Aquest camp és obligatori',
        ERR_POSITIVE: 'Introdueix un import més gran que 0',
        ERR_MAXLENGTH: 'El motiu no pot superar els 255 caràcters',
        ERR_INVALID: 'Camp invàlid',
        TITLE_CREDITS: 'Nou moviment de crèdits',
        SUBTITLE_CREDITS: "Suma o treu crèdits de l'app. L'usuari veurà «Ingrés manual» o «Retirada manual» al seu historial de crèdits; el motiu queda només per a l'equip.",
        TARGET_ARIA: 'Què vols moure',
        TARGET_WALLET: 'Saldo (€)',
        TARGET_CREDITS: 'Crèdits',
        KIND_DEPOSIT_HINT_CREDITS: "Afegeix crèdits a l'usuari",
        KIND_WITHDRAW_HINT_CREDITS: "Treu crèdits a l'usuari",
        AMOUNT_CREDITS: 'Crèdits',
        SUFFIX_CREDITS: 'cr.',
        ERR_INTEGER: 'Els crèdits han de ser un nombre enter',
        CURRENT_CREDITS: 'Crèdits actuals',
        CREDITS_AFTER: 'Crèdits després del moviment',
        EXCEEDS_CREDITS: "La retirada supera els crèdits de l'usuari.",
        LOGGED_WITHDRAW_CREDITS: 'Queda registrat com a «Retirada manual» a la pestanya Moviments (crèdits).',
        LOGGED_DEPOSIT_CREDITS: 'Queda registrat com a «Ingrés manual» a la pestanya Moviments (crèdits).',
        ACTION_WITHDRAW_CREDITS: 'Retirar crèdits',
        ACTION_DEPOSIT_CREDITS: 'Ingressar crèdits',
        CREDIT_ONE: 'crèdit',
        CREDIT_MANY: 'crèdits',
        SUCCESS_WITHDRAW_TEXT_CREDITS: "L'import s'ha retirat correctament dels crèdits de l'usuari.",
        SUCCESS_DEPOSIT_TEXT_CREDITS: "L'import s'ha afegit correctament als crèdits de l'usuari.",
      },
      CREDITS: {
        SHOWING: 'Mostrant <b>{{count}}</b> de <b>{{total}}</b> moviments',
        TITLE: 'Moviments de crèdits',
        SUBTITLE: "Crèdits de l'app (bonus, incentius, cupons i ajustos manuals).",
        CURRENT_BALANCE: 'Saldo actual',
        CREDITS_LOWER: 'crèdits',
        RELOAD: 'Recarrega',
        LOADING: 'Carregant crèdits…',
        RETRY: 'Torna-ho a provar',
        EMPTY: 'Aquest usuari no té moviments de crèdits.',
        TH_DATE: 'Data',
        TH_TYPE: 'Tipus',
        TH_REASON: 'Motiu',
        TH_CREDITS: 'Crèdits',
        TH_BALANCE: 'Saldo després del moviment',
        NO_TYPE: 'Sense tipus',
        BY: 'per {{name}}',
        PAGE: 'Pàgina',
        OF: 'de',
        PREV_PAGE: 'Pàgina anterior',
        NEXT_PAGE: 'Pàgina següent',
        ERROR_LOAD: "No s'han pogut carregar els crèdits de l'usuari.",
        TYPES: {
          VERIFY_ROUTINE: 'Verificació de rutina',
          CREATE_ROUTINE: 'Creació de rutina',
          TRIP_PAYMENT: 'Pagament de viatge amb crèdits',
          TRIP_BONUS: 'Bonus per viatge finalitzat',
          RIDER_FINISHED_TRIP: 'Viatge de passatger finalitzat',
          COUPON_EXCHANGE: 'Cupó bescanviat',
          SUBSIDY_REFUND: 'Reemborsament de subvenció corporativa',
          INCENTIVE_VERIFY_DNI: 'Bo de benvinguda · verificació del DNI',
          INCENTIVE_NO_TRIPS: 'Bo de primer viatge',
          INCENTIVE_INACTIVE: 'Bo de reactivació',
          MANUAL_CREDIT_INCOME: 'Ingrés manual de crèdits',
          MANUAL_CREDIT_WITHDRAWAL: 'Retirada manual de crèdits',
        },
      },
    },
  },
};
